import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=0d292378&scoped=true"
import script from "./RegionsList.vue?vue&type=script&lang=js"
export * from "./RegionsList.vue?vue&type=script&lang=js"
import style0 from "./RegionsList.vue?vue&type=style&index=0&id=0d292378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d292378",
  null
  
)

export default component.exports